import * as React from "react";
import styled from "styled-components";
import { Anchor, Box, Button, FileInput, Text } from "grommet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

let Rating = ({ rating }) => {
    return (
        <div>
            <FontAwesomeIcon icon={["fad", "star-exclamation"]} color={"white"} swapOpacity></FontAwesomeIcon>{" "}
            <Text size="small" color="gray">
                Not yet rated
            </Text>
        </div>
    );
    // return (
    //     <div>
    //         <FontAwesomeIcon icon={["fad", "thumbs-up"]} color={"white"} swapOpacity></FontAwesomeIcon>{" "}
    //         <Text size="small" color="status-ok">
    //             {rating} 94% Positive
    //         </Text>
    //     </div>
    // );
};

export default Rating;
